import '@src/bootstrap';
import MainLayout  from './layouts/main-page.vue';
import router      from './routes/routes';
import store       from '../../store';
import i18n        from '../../i18n';
import Vue         from 'vue';

import '../../../assets/scss/toaster.scss';
import 'swiper/dist/css/swiper.css';
import 'vue-tel-input/dist/vue-tel-input.css';
import PreLoader from '../../components/pre-loader';

import VeeValidate from 'vee-validate';
import * as VueGoogleMaps from 'vue2-google-maps';
import Toaster from 'v-toaster';
import VueLazyload from 'vue-lazyload'
// @TODO - remove VueLazyImageLoading and replace with VueLazyload
import VueLazyImageLoading from 'vue-lazy-image-loading';
import infiniteScroll from 'vue-infinite-scroll';
import VModal from 'vue-js-modal';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Pagination from 'vue-pagination-2';
import VueYoutube from 'vue-youtube';
import VueMeta from 'vue-meta';

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

Vue.use(VueYoutube);
Vue.use(VueAwesomeSwiper, {
    lazy: {loadPrevNext: true},
    mousewheel: {invert: true},
    preloadImages: false,
    initialSlide: 1,
});
Vue.use(Pagination);
Vue.use(Toaster, {timeout: 5000});
Vue.use(VueMoment, {moment});
Vue.use(VModal, { dynamic: true, injectModalsContainer: true});
Vue.use(VeeValidate);
Vue.use(infiniteScroll);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCZx_nWeqh0kp2OKLviJ_DV-bVus2SFoK0',
    libraries: 'places',
    language: 'en',
    maptype: 'roadmap',
  }
});
Vue.component('pre-loader', PreLoader);
Vue.use(VueLazyload, {
  loading: '../../../vue-app/assets/img/loader-black.svg',
  attempt: 1
})
Vue.use(VueLazyImageLoading, {
  placeholder: '../../../vue-app/assets/img/loader-black.svg',
  blur: 0,
  size: 'contain',
  position: 'center center',
  repeat: 'no-repeat'
});

new Vue({
	el : '#company',
  i18n,
	router,
  store,
	render : h => h(MainLayout)
});
